import { render, staticRenderFns } from "./BpRandomPizza.vue?vue&type=template&id=f5f393a6&"
import script from "./BpRandomPizza.vue?vue&type=script&lang=js&"
export * from "./BpRandomPizza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports